export function formatExpertName(value = "") {
  const name = String(value).trim().replace(/\s+/g, " ");
  if (!name || name !== name.toLocaleLowerCase("da-DK")) return name;
  return name.replace(/(^|[\s'-])([\p{L}])/gu, (_, prefix, letter) => (
    `${prefix}${letter.toLocaleUpperCase("da-DK")}`
  ));
}

export function expertDescriptor(expert = {}) {
  const headline = String(expert.headline || "").trim();
  const specialties = (expert.specialties || [])
    .map((item) => String(item || "").trim())
    .filter(Boolean)
    .filter((item) => !headline.toLocaleLowerCase("da-DK").includes(item.toLocaleLowerCase("da-DK")));
  return [headline || "Ekspert", ...specialties].join(" · ");
}
